import { useEffect, useState } from "react";
import { api, fmtDate } from "../../lib/api";
import { Building2 } from "lucide-react";
import { Badge } from "../../components/ui/badge";

export default function AdminBusinesses() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/admin/businesses").then((r) => setItems(r.data)); }, []);

    return (
        <div data-testid="admin-businesses-page">
            <h1 className="font-display text-2xl font-semibold text-[#0A1930]">Businesses</h1>
            <p className="text-sm text-slate-500 mt-1 mb-6">{items.length} MSMEs onboarded</p>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                {items.map((b) => (
                    <div key={b.id} className="bg-white rounded-2xl border border-slate-200 p-5 product-shadow" data-testid={`biz-card-${b.id}`}>
                        <div className="flex items-center gap-3">
                            <div className="size-12 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center">
                                <Building2 size={20} />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="font-display font-semibold text-[#0A1930] truncate">{b.name}</div>
                                <div className="text-xs text-slate-500 font-mono">{b.registration_no}</div>
                            </div>
                            <Badge className="bg-emerald-50 text-emerald-700 border-emerald-200">Verified</Badge>
                        </div>
                        <div className="mt-4 flex justify-between text-sm">
                            <div>
                                <div className="text-xs text-slate-500">Owner</div>
                                <div className="font-semibold mt-0.5">{b.owner?.full_name || "—"}</div>
                            </div>
                            <div className="text-right">
                                <div className="text-xs text-slate-500">Score</div>
                                <div className="font-bold mt-0.5">{b.business_score}</div>
                            </div>
                            <div className="text-right">
                                <div className="text-xs text-slate-500">Joined</div>
                                <div className="text-xs mt-0.5">{fmtDate(b.created_at)}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
